<template>
  <v-layout
    row
    wrap
    fill-height
  >
    <v-card
      class="mx-auto align-self-center"
      color="white"
      elevation-1
      hover
      width="400"
    >
      <v-card-title>
        <h1 class="primary--text font-weight-regular mx-auto">
          Mis Datos
        </h1>
      </v-card-title>

      <v-text-field
        v-model="userForm.email"
        class="mx-4"
        label="Correo Electronico"
      />

      <v-text-field
        v-model="userForm.phone"
        class="mx-4"
        label="Celular"
      />

      <!--
       <v-text-field
        v-model="userForm.password"
        class="mx-4"
        label="Contraseña"
      />

      <v-text-field
        v-model="userForm.indicio"
        class="mx-4"
        label="Indicio de Contraseña"
      />
      -->

      <v-card-actions>
        <v-layout
          row
          wrap
        >
          <v-btn
            :disabled="!checkDisabled"
            class="primary ma-3"
            block
            @click="signUpPatient"
          >
            Actualizar
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
import { actualizarPaciente } from '../api/userEndpoints'
import { mapGetters } from 'vuex'

export default {
  name: 'SettingsView',
  data () {
    return {
      menu: false,
      userForm: {
        password: null,
        indicio: null,
        email: null,
        phone: null
      }
    }
  },
  computed: {
    ...mapGetters(['user']),
    checkDisabled () {
      return this.userForm.email && this.userForm.phone
    }
  },
  async mounted () {
    this.userForm = { ...this.user }
  },
  methods: {
    async signUpPatient () {
      if (this.checkDisabled) {
        const newUser = { ...this.userForm }
        let prepareObject = {
          pacienteId: this.user.id,
          password: newUser.password,
          indicio: newUser.indicio,
          email: newUser.email,
          celular: newUser.phone
        }

        const updatedUser = await actualizarPaciente(prepareObject)
        if (updatedUser.respuesta === 'ERROR') {
          this.$createAlert({
            message: updatedUser.mensaje,
            type: 'error',
            duration: 5000
          })
        } else {
          this.$createAlert({
            message: updatedUser.mensaje,
            type: 'success',
            duration: 3000
          })
          await this.$store.dispatch('updateUser', { phone: updatedUser.celular, email: updatedUser.email, password: updatedUser.password, indicio: updatedUser.indicio })
          this.$router.replace('/')
        }
      }
    }
  }
}
</script>

<style scoped lang="sass">
  .progress-circle
    margin: 40vh auto
</style>
